import $ from 'jquery';
import 'jquery-touch-events';
import 'lightcase';
import MobileDetect from 'mobile-detect';
import sweetalert from 'sweetalert';

// This function is called from mounted() AND updated() of eight different components
// (VGallery, VGalleryVideos, VGalleryInspections, VGalleryInspectionsPublic, VLightcasePreview,
// VLightcaseHolder, Members, ThemeGallery). VLightcaseHolder is rendered once PER PHOTO, so a
// property with a 260 photo Dump used to call this 260 times on a single page load, and every
// one of those calls added a window resize listener, added another delegated document click
// handler, and re-ran .lightcase() over every lightcase link on the page. The overlay stopped
// opening at all, for the Dump and for every other gallery on the page with it.
//
// Three guards, and nothing else about the configuration changes:
//   1. calls coalesce to at most one apply per animation frame
//   2. the window and document listeners bind exactly once, ever
//   3. .lightcase() only ever touches links it has not bound before
let lightcaseApplyScheduled = false;
let lightcaseOneTimeBound = false;
let zoomStepCount = 0;

// Lightcase toggles this class synchronously in _open() and close(). window.lightcase cannot
// tell: it only exports the library's public methods, not its isOpen flag.
export function isLightcaseViewerOpen() {
  return document.documentElement.classList.contains('lightcase-open');
}

// Everything the hooks below add outside the viewer for one opening: the fixed approve/delete
// controls appended to <body>, the print button, the body/thumbnail state classes, the overlay
// moved into a modal and the zoom state. Idempotent; runs before every opening (and every
// previous/next step), on close and on cleanup.
export function resetTemporaryLightcaseUi() {
  $('.v-gallery__done--popup, .v-gallery__close--popup').remove();
  $('.js-lightcase-print-btn').remove();
  $('body').removeClass('is-preview-opened modal-is-opened');
  $('.v-gallery__thumbnail-wrap').removeClass('is-clicked-to-preview');
  $('#lightcase-overlay').appendTo('body');
  zoomStepCount = 0;
}

// Lightcase 2.5.0 only skips the callbacks of its fade-IN transitions once the viewer is closed.
// The fade-OUT callback in _processContent still runs _loadContent -> onStart and then onFinish,
// so a close during the opening transitions (easily hit on a slow phone) ran onClose first and
// then re-created the fixed delete control and the is-clicked-to-preview state, with nothing left
// to remove them - a live delete button stranded at the top of the page. A hook of an opening
// that was already closed therefore only clears up.
function onlyWhileViewerOpen(hook) {
  return function (...hookArguments) {
    if (!isLightcaseViewerOpen()) {
      resetTemporaryLightcaseUi();
      return undefined;
    }
    return hook.apply(this, hookArguments);
  };
}

// The key a rotated preview override belongs to, so it is never applied to a different photo
// that later reuses the same thumbnail element.
function previewSourceKey($origin, image) {
  return $origin.attr('data-src') || (image && image.getAttribute('data-src')) || '';
}

// The image the viewer loads: the holder's data-src, unless this photo was rotated during this
// page visit (see rememberRotatedPreviewSource).
export function previewSourceFor($origin, image) {
  const override = $origin.attr('data-preview-src');
  if (override && $origin.attr('data-preview-src-for') === previewSourceKey($origin, image)) {
    return override;
  }
  return image.getAttribute('data-src');
}

function withRotationMarker(source) {
  if (!source || /^(blob|data):/.test(source)) {
    return source;
  }
  const marker = 'rotated=' + Date.now();
  if (/[?&]rotated=\d+/.test(source)) {
    return source.replace(/([?&])rotated=\d+/, '$1' + marker);
  }
  return source + (source.indexOf('?') === -1 ? '?' : '&') + marker;
}

// Only after a rotation was saved: the next open must not show the browser's cached, unrotated
// copy. Meter-reading photos answer with their fresh versioned URLs; other rotate endpoints
// rewrite the original in place and return nothing, so its current URL gets a one-off marker.
export function rememberRotatedPreviewSource($origin, image, response) {
  const current = image ? previewSourceFor($origin, image) : null;
  const refreshed = (response && response.url) || withRotationMarker(current);
  if (refreshed) {
    $origin.attr('data-preview-src', refreshed);
    $origin.attr('data-preview-src-for', previewSourceKey($origin, image));
  }
}

export default function configureLightcase() {
  if (lightcaseApplyScheduled) {
    return;
  }
  lightcaseApplyScheduled = true;
  const schedule = (typeof requestAnimationFrame === 'function')
    ? requestAnimationFrame
    : (cb) => setTimeout(cb, 0);
  schedule(() => {
    lightcaseApplyScheduled = false;
    applyLightcase();
  });
}

function applyLightcase() {
  const md = new MobileDetect(window.navigator.userAgent);
  const $window = $(window);

  jQuery(document).ready(function ($) {
    
    var resizeTimer;

    if (!lightcaseOneTimeBound) {
      $(window).on('resize', function(e) {

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {

          $('iframe').css('width', '100%');

        }, 250);

      });
    }
    
    var doc = document,
    md = new MobileDetect(window.navigator.userAgent),
    _shrink = 2,
    _force = true,
    _iWidth = $(window).width() - 250,
    _iHeight = $(window).height() - 250,
    changeWidth = false,
    changeMargins = false,
    _width = 800, _height = 500,
    _iframeWidth = 800,
    _iframeHeight = 500;
    
    if (md.mobile() !== "" && md.mobile() !== null) {
      _width = $(window).width() - 20;
      _height = $(window).innerHeight() + 60;
      _iframeHeight = _height - 250;
      
      var _iWidth = $(window).width() - 120;
      if (md.phone()) {
        _iWidth = $(window).width() - 90;
        
      }
      var _iHeight = $(window).innerHeight() - 30;
      _shrink = .75;
      _force = true;
      changeWidth = true;
      if (md.os() === "iOS") {
        changeMargins = true;
      }
      
    }
    
    // Only links this has never bound. lightcase attaches its own click handler on every
    // call, so re-running it over already-bound links stacks handlers that fight each other
    // and the overlay stops opening. New links added by Vue are picked up on the next apply.
    var $unbound = $("a[data-rel^=lightcase]").not('[data-lightcase-bound]');
    if (!$unbound.length) {
      lightcaseOneTimeBound = true;
      return;
    }

    $unbound.attr('data-lightcase-bound', '1').lightcase({
      swipe: true,
      fullscreenModeForMobile: false,
      liveResize: true,
      maxWidth: 1250,
      maxHeight: 1000,
      width: _iWidth,
      height: _iHeight,
      showCaption: false,
      shrinkFactor: _shrink,
      forceWidth: true,
      fixedRatio: true,
      iframe: {
        width: _iWidth,
        height: _iHeight + 12,
      },
      // Every hook of an opening runs through onlyWhileViewerOpen(); the first one clears what a
      // previous opening (or previous/next step) left behind before anything is created.
      onStart: {
        resetTemporaryUi: resetTemporaryLightcaseUi,
        checkIfModalOpened: onlyWhileViewerOpen(function(){
          if($('.v--modal-overlay').length){
            $('body').addClass('modal-is-opened');
            $('#lightcase-overlay').prependTo($('#modals-container'));
          }
        }),
        setDownloadLink: onlyWhileViewerOpen(function () {
          let downloadLink = $(this)[0].attributes['data-download-link'];
          $('.lightcase-icon-download').remove();
          if (downloadLink) {
            $('.lightcase-icon-close').after('<a href="' + downloadLink.nodeValue + '" class="lightcase-icon-download" download></a>')
          }
        }),
        // setSource: function() {
        //   let images = document.getElementById('lightcase-case').getElementsByTagName('img');
        //   if(images){
        //     let lightboxphoto = images[0];
        //     if (lightboxphoto) {
        //       let currSource = lightboxphoto.getAttribute('data-src');
        //       let timeStamp = new Date().getTime().toString();
        //       if(currSource){
        //         lightboxphoto.src = currSource + '?t=' + timeStamp;
        //       }
        //     }
        //   }
        // },
        setImageSize: onlyWhileViewerOpen(function () {
          if (lightcase.getObjectData().type !== 'inline') {
            return;
          }
          
          let type = lightcase.getObjectData().type;
          let url = lightcase.getObjectData().url;
          let imgHolder = $(url).find('.image-holder')[0];
          let image;
          if (type === 'inline') {
            image = $(url).find('img')[0];
          }
          
          if (!image) {
            return false;
          }
          if ($(image)[0].naturalWidth - $(image)[0].naturalHeight > 50) {
            $(imgHolder).addClass('image-landscape');
          } else {
            $(imgHolder).removeClass('image-landscape');
          }
          
          $(image).on('load', function() {
            if ($(image)[0].naturalWidth - $(image)[0].naturalHeight > 50) {
              $(imgHolder).addClass('image-landscape');
            } else {
              $(imgHolder).removeClass('image-landscape');
            }
          });
          
          var degrees = 0;
          
          function rotateImage(direction) {
            var $lightboxphoto = $('#lightcase-case').children().find('img');
            
            if (direction === 'left') {
              degrees -= 90;
            } else {
              degrees += 90;
            }
            
            if (Math.abs(degrees) > 360) {
              degrees = degrees - 360;
            }
            
            if (Math.abs(degrees) === 360) {
              degrees = 0;
            }
            
            $($lightboxphoto).data('angle', degrees);
            $lightboxphoto.css('-ms-transform', 'rotate(' + degrees + 'deg)');
            $lightboxphoto.css('-webkit-transform', 'rotate(' + degrees + 'deg)');
            $lightboxphoto.toggleClass('rotated');
            if ($lightboxphoto.hasClass('rotated')) {
              if ($lightboxphoto[0].naturalWidth > $lightboxphoto[0].naturalHeight) {
                
                if ($(imgHolder).height() < $(imgHolder).width()) {
                  $lightboxphoto.css('max-height', 'none');
                  $lightboxphoto.css('max-width', $(imgHolder).height());
                }
                
              } else if ($lightboxphoto[0].naturalHeight > $lightboxphoto[0].naturalWidth) {
                if ($(imgHolder).width() < $(imgHolder).height()) {
                  $lightboxphoto.css('max-width', 'auto');
                  $lightboxphoto.css('max-height', $(imgHolder).width());
                }
              }
            }
            else {
              $lightboxphoto.css({
                'max-width': '100%',
                'max-height': '100%',
                'min-width': 0
              });
            }
          }
          
          $('.rotate').bind('click', function (event) {
            event.preventDefault();
            rotateImage();
          });
          $('.rotate-left').bind('click', function (event) {
            event.preventDefault();
            rotateImage('left');
          });
          $('.js-confirm-rotate-save').bind('click', function (event) {
            event.preventDefault();
            var $lightboxphoto = $('#lightcase-case').children().find('img');
            var data = $($lightboxphoto).data('angle');
            
            if (data) {
              let rotateUrl = lightcase.origin[0].attributes['data-rotate-url'].nodeValue;
              
              if (rotateUrl) {
                $.ajax({
                  url: rotateUrl,
                  method: 'put',
                  data: {angle: data },
                  success: (response) => {
                    sweetalert(window.app.locales.common.success, 'The data was updated!', 'success');
                    let $origin = lightcase.getObjectData().this;
                    rememberRotatedPreviewSource($origin, $lightboxphoto[0], response);
                    if (response && response.smallUrl) {
                      $origin.css('background-image', 'url("' + response.smallUrl + '")');
                      return;
                    }
                    let thumbnail = $origin[0].style['background-image'];
                    let url = thumbnail.substring(5, thumbnail.length - 2);
                    if(url.indexOf('250x250-resize')!==-1){
                      url=url.replace('large', 'small');
                    }
                    $origin.css('background-image', '');
                    $origin.css('background-image', 'url("' + url + '?t=1")');
                  },
                  error: () => {
                    
                  }
                });
              }
            }
            
          });
        }),
        addClass: onlyWhileViewerOpen(function(){
        $('body').addClass('is-preview-opened');
        }),
        renderButtons: onlyWhileViewerOpen(function () {
            var parent = this.closest('.v-gallery__thumbnail-wrap');

            $('.v-gallery__done--popup, .v-gallery__close--popup ').remove();

            if (parent.find(".v-gallery__done").length) {
                $('<span class="func-gallery-done-btn v-gallery__done v-gallery__done--popup" "><i class="material-icons">' + parent.find(".v-gallery__done .material-icons").text() + '</i></span>').appendTo("body");
            }
            if (parent.find(".v-gallery__close").length) {
                $('<span class="func-gallery-close-btn v-gallery__close v-gallery__close--popup"><i class="material-icons">cancel</i></span>').appendTo("body");
            }
        })
      },
      onBeforeCalculateDimensions : {
        setPrintButton: onlyWhileViewerOpen(function () {
          if(!$('.lightcase-contentInner iframe').length && !$('.lightcase-contentInner .js-video').length){
            $('.js-lightcase-print-btn').remove();
            $('#lightcase-title').before('<button type="button" class="js-lightcase-print-btn lightcase-print-btn" title="Print this document">print</button>');
            $('.js-lightcase-print-btn').on('click', function () {
              window.print();
            });
          } else {
            $('.js-lightcase-print-btn').remove();
          }
        })
      },
      onFinish: {
        // The holder renders <img src="" data-src="..."> so hundreds of hidden holders never load
        // anything; the opened copy gets its real source here. The same URL on every open, so a
        // reopened photo comes from the browser cache instead of a fresh download and decode.
        setSource: onlyWhileViewerOpen(function() {
          let lightboxphoto = document.getElementById('lightcase-case').getElementsByTagName('img')[0];
          if (!lightboxphoto) {
            return;
          }
          let source = previewSourceFor($(this), lightboxphoto);
          if (source && lightboxphoto.getAttribute('src') !== source) {
            lightboxphoto.src = source;
          }
        }),
        addZoomTools: onlyWhileViewerOpen(function(){
          let $selector = '.js-lightcase-image',
          width = 0;
          
          zoomStepCount = 0;
          
          $(document).off('click', '#zoomInIcon');
          $(document).off('click', '#zoomOutIcon');
          $(document).off('click', '#resetZoom');          
          
          $(document).on('click', '#zoomInIcon', function(e){
            e.preventDefault();
            
            let $parent = $(this).parents('.lightcase-holder');
            
            width = parseInt($parent.find($selector).find('img').width());
            
            width += 250;
            zoomStepCount++;
            
            $parent.find($selector).find('img').css({
              'max-width': width,
              'min-width': width,
              'max-height': 'none'
            });
            
            
            $parent.find('#zoomOutIcon').removeClass('disabled');
            
            if(zoomStepCount > 3){
              $(this).addClass('disabled');
              return;
            }
          });
          
          $(document).on('click', '#zoomOutIcon', function(e){
            e.preventDefault();
            
            let $parent = $(this).parents('.lightcase-holder');                
            width -= 250;
            zoomStepCount--;
            
            $parent.find('#zoomInIcon').removeClass('disabled');
            
            $parent.find($selector).find('img').css(
              {
                'min-width': width,
                'max-width': width
              });
              
              if (zoomStepCount <= 0){
                $(this).addClass('disabled');
                
                $parent.find($selector).find('img').css({
                  'max-width': '100%',
                  'max-height': '100%',
                  'min-width': 0
                });
                
                return;
              }
            });
            
          $(document).on('click', '#resetZoom', function(e){
              e.preventDefault();
              let $parent = $(this).parents('.lightcase-holder');
              
              $parent.find($selector).find('img').removeAttr('style');
              
              $parent.find('#zoomInIcon').removeClass('disabled');
              $parent.find('#zoomOutIcon').addClass('disabled');
              width = 0;
              zoomStepCount = 0;
            });
          }),
          addTools: onlyWhileViewerOpen(function(){
            $('.v-gallery__thumbnail-wrap').removeClass('is-clicked-to-preview');
              this.closest('.v-gallery__thumbnail-wrap').addClass('is-clicked-to-preview');
          })
        },
      onClose: {
          clean: resetTemporaryLightcaseUi
        },
      // Runs once the close transitions finished - after any hook a late opening callback ran.
      onCleanup: {
          clean: resetTemporaryLightcaseUi
        }
      });
      
      
      if (!lightcaseOneTimeBound) {
        $(document).on('click', '.v-gallery__thumbnail', function (e) {
          if (e.originalEvent !== undefined) {
            let $item = $(this).closest('.v-gallery__thumbnail-wrap');

            $item.removeClass('is-clicked-to-preview');

            if($item.find('.v-gallery__done').length || $item.find('.v-gallery__close').length){
              $item.addClass('is-clicked-to-preview');
            }
          }
        });
      }

      lightcaseOneTimeBound = true;
    });
}